import React, { useEffect, useState } from "react";
import PresentToAllIcon from "@material-ui/icons/PresentToAll";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import axios from "axios";
import ReactDragList from "react-drag-list";
import { Avatar, IconButton, InputBase, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, makeStyles, Tooltip } from "@material-ui/core";
import { combineProps, deepClone } from "../../../../../../helpers/objectHelper";
import { meetingService } from "../../../../../../services/meeting/meeting.service";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import { Label, Spinner } from "reactstrap";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import SortIcon from "@material-ui/icons/Sort";
import { Preset } from "../../../../../preset/Preset";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import MobileFriendlyIcon from "@material-ui/icons/MobileFriendly";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    backgroundColor: "#3a3b3c",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "100%",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#FFFFFF99",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#FFFFFF99",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));

export function MeetingLayouts(props) {
  const [layouts, setLayouts] = useState([]);
  const [activateLayoutId, setActiveLayoutId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unlocked, onUnlock] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [isPresetOpen, setPresetOpen] = useState(false);
  const [filter, setFilter] = React.useState("");
  const classes = useStyles();

  const searchFilter = (e) => {
    setFilter(e.target.value);
  };
  const { hubConnection, eventId, connected } = props;
  useEffect(() => {}, []);

  useEffect(() => {
    if (eventId && hubConnection && connected) {
      fetchLayouts();
      configureHubEvents();
    }
  }, [eventId, hubConnection, connected]);

  const configureHubEvents = () => {
    hubConnection.on("onGetActiveMeetingLayout", (layout) => {
      if (layout) {
        setActiveLayoutId(layout.meetingLayoutId);
      } else {
        setActiveLayoutId(null);
      }
    });
    hubConnection.invoke("getActiveMeetingLayout", eventId);
  };
  const changeLayoutStatus = (meetingLayoutId) => {
    if (!hubConnection || hubConnection.connectionState != 1) return;
    hubConnection.invoke("changeLayoutStatus", eventId, meetingLayoutId);
  };

  const onLayoutUpdate = (layouts) => {
    setLayouts(layouts);
  };
  const onSort = (event, dataSource) => {
    const sortedLayouts = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i;
      return el;
    });
    setLayouts(sortedLayouts);
    setHasChanged(true);
  };
  const fetchLayouts = () => {
    meetingService.getLayouts(eventId).then((layouts) => {
      setLayouts(layouts);
      setLoading(false);
    });
  };
  const save = () => {
    axios
      .put(
        `./api/meeting/updatelayouts/`,
        layouts
          .filter((l) => l.eventId == eventId)
          .map((l) => {
            let ll = deepClone(l);
            ll.meetingModules = null;
            return ll;
          })
      )
      .then(({ data }) => {
        setLayouts(data);
      });
  };
  const api = {
    /*     activateLayout, */
    changeLayoutStatus,
    layouts,
    filter,
    onSort,
    unlocked,
    activateLayoutId,
    ...props,
  };
  if (loading) return <Spinner />;
  return (
    <div style={{ marginTop: 10, overflowX: "hidden" }}>
      {isPresetOpen ? <Preset {...props} close={() => setPresetOpen(false)} /> : null}
      <div style={{ width: "100%", display: "inline-flex" }}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            onInput={searchFilter}
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
        <IconButton
          onClick={() => onUnlock(!unlocked)}
          edge="start"
          style={{
            padding: "0px 10px",
            color: unlocked ? "#fff" : "#ffffff99",
          }}
        >
          <Tooltip title={<SystemLabel name="Sort" />}>
            <SortIcon />
          </Tooltip>
        </IconButton>
        {unlocked ? (
          <IconButton
            onClick={save}
            disabled={!hasChanged}
            edge="start"
            style={{
              padding: "0px 10px",
              color: !hasChanged ? "rgba(255, 255, 255, 0.28)" : "#fff",
            }}
          >
            <SaveIcon />
          </IconButton>
        ) : null}
        <IconButton
          onClick={() => setPresetOpen(true)}
          edge="start"
          style={{
            padding: "0px 10px",
            color: !hasChanged ? "rgba(255, 255, 255, 0.28)" : "#fff",
          }}
        >
          <GroupWorkIcon />
        </IconButton>
      </div>
      <LayoutList {...api} />
    </div>
  );
}

const LayoutList = (props) => {
  const { layouts, activateLayoutId, activeMobileLayout, eventId, events, unlocked, eventName, filter, onSort } = props;
  if (layouts.length == 0) return null;
  if (unlocked) {
    return (
      <ul
        className="dark-list"
        style={{
          maxHeight: "calc(96vh - 241px)",
          overflowY: "auto",
          marginTop: 10,
          padding: "0px 10px",
        }}
      >
        <ReactDragList
          animation={10}
          dataSource={layouts.filter((l) => {
            let returnable = l.eventId == eventId;
            if (filter) {
              returnable = l.name.toLowerCase().includes(filter.toLowerCase()) && l.eventId == eventId;
            }
            return returnable;
          })}
          rowKey={"meetingLayoutId"}
          className="simple-drag"
          rowClassName="simple-drag-row"
          handles={true}
          onUpdate={(event, dataSource) => onSort(event, dataSource)}
          row={(q, index) => {
            return (
              <div key={index} style={{ margin: 5 }}>
                <LayoutListItem {...combineProps([props, q, { active: false, drag: true }])} />
              </div>
            );
          }}
        />
      </ul>
    );
  }
  return (
    <ul
      className="dark-list"
      style={{
        maxHeight: "calc(96vh - 241px)",
        overflowY: "auto",
        marginTop: 10,
        padding: "0px 10px",
      }}
    >
      {layouts.find((l) => l.mobile) ? (
        <Label className="secondary-text">
          <SystemLabel name="DesktopLayouts" />
        </Label>
      ) : null}
      {layouts
        .filter((l) => {
          let returnable = l.eventId == eventId;
          if (filter) {
            returnable = l.name.toLowerCase().includes(filter.toLowerCase()) && l.eventId == eventId;
          }
          if (l.mobile) return false;
          return returnable;
        })
        .map((l, ii) => {
          let active = l.meetingLayoutId == activateLayoutId;
          return (
            <div key={ii}>
              <LayoutListItem {...combineProps([props, l, { active }])} />
            </div>
          );
        })}
      {layouts.find((l) => l.mobile) ? (
        <>
          <Label className="secondary-text">
            <SystemLabel name="MobileLayouts" />
          </Label>
          {layouts
            .filter((l) => {
              let returnable = l.eventId == eventId;
              if (filter) {
                returnable = l.name.toLowerCase().includes(filter.toLowerCase()) && l.eventId == eventId;
              }
              if (!l.mobile) return false;
              return returnable;
            })
            .map((l, ii) => {
              let active = l.meetingLayoutId == activeMobileLayout?.meetingLayoutId;
              return (
                <div key={ii}>
                  <LayoutListItem {...combineProps([props, l, { active }])} />
                </div>
              );
            })}
        </>
      ) : null}
    </ul>
  );
};


const PresenterIcon = ({ active }) => (active == true ? <CancelPresentationIcon /> : <PresentToAllIcon />);

const LayoutListItem = (props) => {
  const { active, name, mobile, changeLayoutStatus, meetingLayoutId, drag = false } = props;
  return (
    <ListItem className={active == true ? "active-moderator-li" : ""}>
      <ListItemAvatar>
        <Avatar className="list-avatar">{mobile ? <MobileFriendlyIcon /> : <ViewCompactIcon />}</Avatar>
      </ListItemAvatar>
      <ListItemText className="primary-text" primary={name} />
      {!drag ? (
        <ListItemSecondaryAction>
          <IconButton onClick={() => changeLayoutStatus(meetingLayoutId)} className="primary-text">
            <PresenterIcon active={active} />
          </IconButton>
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
};
